module.exports = __webpack_public_path__ + "img/叶坪红军烈士纪念亭.abf46a5e.png";